import Vue from 'vue'
import App from './App.vue'
import router from '../Router'
import bootstrap from 'bootstrap-vue'
import axios from 'axios'
import i18n from './i18n'
//import { sync } from 'vuex-router-sync';



// eslint-disable-next-line no-undef

//sync(router);
Vue.config.productionTip = false
Vue.use(bootstrap);

Vue.prototype.$http = axios;

router.beforeEach((to, from, next) => {
    let cust = to.params.cust
    if (cust != null) {
        axios.get(`/policy/GetIsGeo/${cust}`).then(r => {
            if (r.data == 0) {
                i18n.locale = "en";
            };
        }).catch((e) => {
            console.log(e)
        })
    }
    next()
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
